<template>
    <main id="register-wrapper">
        <div id="registerpage">
            <breadcrumb :breadcrumb="[
                { title: 'Community', url: app_url, status: false },
                { title: 'Register', url: app_url + '/register', status: true }
            ]"></breadcrumb>
            <div class="container py-4">
                <div class="row justify-content-center">
                    <div class="col-md-6">
                        <div id="card-register" class="card mb-4">
                            <div class="card-body">
                                <div v-if="!showRegisterPhone">
                                    <h3 class="title">Daftar</h3>
                                    <div class="row">
                                        <div class="col">
                                            <div class="row">
                                                <div class="col-md-6 my-2">
                                                    <div class="box-socmed-btn">
                                                        <a @click="registerPhoneTracker" class="btn btn-socmed"
                                                            id="btn-login-handphone">
                                                            <div class="icon-section text-center login-handphone">
                                                                <span class="fa fa-phone"></span>
                                                            </div>
                                                            <span class="text-btn">Daftar dengan Handphone/Email</span>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 my-2">
                                                    <div class="box-socmed-btn">
                                                        <a @click="registerGoogleTracker"
                                                            :href="api_url + '/auth/social/google'"
                                                            class="btn btn-socmed" id="btn-register-google">
                                                            <div class="icon-section text-center">
                                                                <img class="img-button"
                                                                    :src="base_url + '/images/google.svg'"
                                                                    alt="google-img">
                                                            </div>
                                                            <span class="text-btn">Daftar dengan Google</span>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row text-center py-2">
                                        <div class="col">
                                            <br>
                                            <p>Sudah punya akun ? <a :href="app_url + '/login'"
                                                    id="login-link"><strong>Login</strong></a></p>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="relativebox">

                                    <div class="message-box" v-if="showMessage">
                                        <div class="message-content">
                                            <div v-html="message"></div>
                                            <div class="row-button">
                                                <a :href="app_url + '/login'" class="btn btn-red">Login</a>
                                                <a :href="app_url + '/forgot'" class="btn btn-black">Lupa Akun</a>
                                            </div>
                                        </div>
                                    </div>
                                    <form v-if="!showOtp" method="POST" @submit.prevent="onSubmit"
                                        @keydown="form.errors.clear($event.target.name)" enctype="multipart/form-data">
                                        <div id="card-register" class="cards">
                                            <div class="card-bodys">
                                                <h3 class="title">Daftar Honda Community</h3>

                                                <div class="form-group row">
                                                    <div class="col">
                                                        <label class="label-form" for="hp">Masukkan No.
                                                            Handphone</label>
                                                        <div class="phonebox">
                                                            <span class="input62">+62</span>
                                                            <input type="number" class="form-control form-register"
                                                                id="hp" aria-describedby="hp" placeholder="8XXXXXXXX"
                                                                v-model="form.phone" />
                                                        </div>
                                                        <span v-if="showWarning">Pastikan nomor Handphone yang digunakan
                                                            sudah benar, jika sudah silahkan klik Selanjutnya</span>
                                                        <span class="help-block" v-if="form.errors.has('phone')"
                                                            v-text="form.errors.get('phone')">
                                                        </span>
                                                    </div>
                                                </div>

                                                <div class="form-group row" v-if="showMail">
                                                    <div class="col">
                                                        <label class="label-form" for="email">Masukkan Email
                                                            anda</label>
                                                        <input type="text" class="form-control form-register" id="email"
                                                            aria-describedby="email" placeholder="mail@astra-honda.com"
                                                            v-model="form.email" />
                                                        <span class="help-block" v-if="form.errors.has('email')"
                                                            v-text="form.errors.get('email')">
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="row justify-content-center">
                                                    <div v-if="loader" class="loading loading-double"></div>
                                                    <button v-else type="submit" class="btn mx-2 btn-red"
                                                        data-toggle="modal">
                                                        Selanjutnya
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="row text-center py-2">
                                                <div class="col">
                                                    <br>
                                                    <p>Sudah punya akun ? <a :href="app_url + '/login'"
                                                            id="login-link"><strong>Login</strong></a></p>
                                                </div>
                                            </div>
                                        </div>
                                    </form>

                                    <form v-if="showOtp && !showPin" method="POST" @submit.prevent="onSubmitWithOtp"
                                        @keydown="otpForm.errors.clear($event.target.name)"
                                        enctype="multipart/form-data">
                                        <div id="card-register" class="cards">
                                            <div class="message-box" v-if="showMessageOtp">
                                                <div class="message-content">
                                                    <div v-html="member.message"></div>
                                                    <button class="btn btn-red"
                                                        @click="showMessageOtp = !showMessageOtp; registerStep3Tracker(true);">
                                                        Selanjutnya </button>
                                                </div>
                                            </div>
                                            <div class="card-bodys">
                                                <h3 class="title">Verifikasi</h3>
                                                <div class="form-group row">
                                                    <div class="col">
                                                        <label class="label-form" for="hp">No. Handphone</label>
                                                        <div class="phonebox">
                                                            <span class="input62">+62</span>
                                                            <input type="number" class="form-control form-register"
                                                                id="hp" aria-describedby="hp" placeholder="8XXXXXXXX"
                                                                v-model="otpForm.phone" disabled />
                                                        </div>
                                                        <span class="help-block" v-if="otpForm.errors.has('phone')"
                                                            v-text="otpForm.errors.get('phone')">
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <div class="col">
                                                        <label class="label-form" for="emailform">Email</label>
                                                        <input type="text" class="form-control form-register"
                                                            id="emailform" aria-describedby="email"
                                                            placeholder="Masukkan Email Anda" v-model="otpForm.email"
                                                            disabled />
                                                        <span class="help-block" v-if="otpForm.errors.has('email')"
                                                            v-text="otpForm.errors.get('email')">
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <div class="col">
                                                        <label class="label-form" for="hp">Kode OTP</label>
                                                        <input type="number" class="form-control form-register" id="otp"
                                                            aria-describedby="otp" placeholder="Masukkan No OTP"
                                                            v-model="otpForm.otp" v-mask="'######'" />
                                                        <span class="help-block" v-if="otpForm.errors.has('otp')"
                                                            v-text="otpForm.errors.get('otp')">
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <div class="col">
                                                        <label class="label-form" for="pin">Masukkan PIN Baru</label>
                                                        <input type="number" class="form-control form-register" id="pin"
                                                            aria-describedby="pin"
                                                            placeholder="Masukkan 6 Digit PIN Baru"
                                                            v-model="otpForm.pin" v-mask="'######'" />
                                                        <span class="help-block" v-if="otpForm.errors.has('pin')"
                                                            v-text="otpForm.errors.get('pin')">
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <div class="col">
                                                        <label class="label-form" for="hp">Konfirmasi Pin</label>
                                                        <input type="number" class="form-control form-register"
                                                            id="pin_confirmation" aria-describedby="pin_confirmation"
                                                            placeholder="Konfirmasi Pin"
                                                            v-model="otpForm.pin_confirmation" v-mask="'######'" />
                                                        <span class="help-block"
                                                            v-if="otpForm.errors.has('pin_confirmation')"
                                                            v-text="otpForm.errors.get('pin_confirmation')">
                                                        </span>
                                                    </div>
                                                </div>
                                                <div v-if="loader" class="loading loading-double"></div>
                                                <div v-else class="row-button">
                                                    <div class="sendback">
                                                        <button type="button" class="btn btn-black"
                                                            :disabled="countDown != 0" @click="backOTp">
                                                            Kirim Ulang OTP
                                                        </button>
                                                        <small v-if="countDown > 0"> Kirim Ulang OTP Dalam {{ countDown
                                                            }}
                                                            Detik</small>
                                                    </div>
                                                    <button type="submit" class="btn btn-red" style="margin:0">
                                                        Verifikasi
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import BreadCrumb from "../../widget/BreadCrumb";
import { sha256, sha224 } from 'js-sha256';


export default {
    components: {
        breadcrumb: BreadCrumb
    },
    data() {
        return {
            base_url: '',
            app_url: '',
            api_url: '',
            mobile: false,
            countDown: 60,
            showRegisterPhone: false,
            showOtp: false,
            showPin: false,
            showWarning: false,
            showMessage: false,
            showMessageOtp: false,
            message: '',
            loader: false,
            showMail: false,
            member: null,
            form: new Form({
                _token: token,
                phone: '',
                email: '',
            }),
            otpForm: new Form({
                _token: token,
                phone: '',
                email: '',
                otp: '',
                pin: '',
                pin_confirmation: '',
            }),
            otpFormPin: new Form({
                _token: token,
                phone: '',
                pin: '',
                pin_confirmation: '',
            }),
            tokenForm: new Form({
                _token: token,
                token: '',
            }),
        };
    },
    watch: {
        otpForm: {
            handler: function (val, oldVal) {
                this.otpForm.email = val.email.toLowerCase();
            },
            deep: true
        },
        form: {
            handler: function (val, oldVal) {
                this.form.email = val.email.toLowerCase();
            },
            deep: true
        }
    },
    created() {
        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.mobile = isMobile;
        localStorage.setItem('method', 'Register');

        window.location.href = app_url + '/register/independent';
    },
    methods: {
        // GTM Tracker
        registerMethodDataLayer(method) {
            var data = {
                'event': 'registerStep1',
                'eventDetail.category': 'Registration',
                'eventDetail.action': 'Select register method',
                'eventDetail.label': method,
            };
            dataLayer.push(data);
        },
        registerPhoneTracker() {
            this.showRegisterPhone = true;
            this.registerMethodDataLayer('Phone');
        },
        registerGoogleTracker() {
            this.registerMethodDataLayer('Google');
        },

        // Generic function to push data to dataLayer
        pushToDataLayer(event, category, action, label, phone = '', email = '') {
            const data = {
                'event': event,
                'eventDetail.category': category,
                'eventDetail.action': action,
                'eventDetail.label': label,
            };
            if (phone !== '') {
                data.phone = sha256(phone);
            }
            if (email !== '') {
                data.email = sha256(email);
            }
            dataLayer.push(data);
        },
        registerStep2Tracker(phone) {
            this.pushToDataLayer('registerStep2', 'Registration', 'Submit phone number', sha256(`62${phone}`));
        },

        registerStep3Tracker(confirm) {
            const label = confirm ? 'Yes' : 'No';
            this.pushToDataLayer('registerStep3', 'Registration', 'Confirm phone number', label, `62${this.form.phone}`, this.form.email);
        },

        registerStep4Tracker(label = '') {
            this.pushToDataLayer('registerStep4', 'Registration', 'OTP verification', label, `62${this.form.phone}`, this.form.email);
        },
        // End of GTM Tracker

        onSubmit() {
            this.loader = true;
            this.form.post(api_url + "/member/register")
                .then((response) => {
                    this.loader = false;
                    if (!response.status && response.oldmember) {
                        this.showMessage = true;
                        this.message = response.message;
                    }
                    if (!response.status && !response.oldmember) {
                        this.form.phone = response.phone;
                        this.registerStep2Tracker(this.form.phone)
                        this.showMail = true;
                    }
                    if (response.status) {
                        // this.gtmTrackerStep2(response.encryptPhone);
                        this.showMessageOtp = true;
                        this.otpForm.phone = response.phone;
                        this.otpForm.email = response.email;
                        this.form.phone = response.phone;
                        this.form.email = response.email;
                        this.form._token = token;
                        this.member = response.member;
                        this.showOtp = true;
                        this.countDown = 60;
                        this.countDownTimer();
                    }
                })
                .catch((response) => {
                    this.loader = false;
                    console.log(response);
                });
        },
        onSubmitWithOtp() {
            this.loader = true;
            this.registerStep4Tracker('Verify');
            this.otpForm.post(api_url + "/member/register/phone/otp")
                .then((response) => {
                    localStorage.setItem('user', JSON.stringify(response.data))
                    window.location.href = this.app_url + '/register-user'
                })
                .catch((response) => {
                    this.loader = false;
                    console.log("ERROR");
                });
        },
        onSubmitPin() {
            this.otpFormPin.post(api_url + "/member/register-pin")
                .then((response) => {
                    if (response.status) {
                        localStorage.setItem('token', response.token)
                        localStorage.setItem('user', JSON.stringify(response.data))
                        if (response.data.completed == true || response.data.completed == 'true') {
                            window.location.href = this.app_url + '/hcid'
                        } else {
                            window.location.href = this.app_url + '/register-user'
                        }
                    }
                })
                .catch((response) => {
                    console.log("ERROR");
                });
        },
        backOTp() {
            this.showOtp = false;
            this.showWarning = true;
            this.registerStep4Tracker('Resend OTP')
        },
        countDownTimer() {
            if (this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1
                    this.countDownTimer()
                }, 1000)
            }
        },
    }
};
</script>

<style scoped lang="scss">
#registerpage {
    background: #000000;

    #card-register {
        background: #FFFFFF;
        border-radius: 10px;
        // font-family: Inter;
    }

    .title {
        color: #000000;
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        margin-bottom: 1rem;
    }

    .btn {
        width: 100%;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        padding-left: 0;
        text-align: center;

        &:hover {
            color: #fff;
        }

        max-width: 150px;
        margin:0 auto;
        border-radius: 10px;
    }

    .btn-socmed {
        max-width: none;
        text-align: left;
        align-items: center;
        display: flex;
    }

    #btn-register-google {
        background: #4081EC;
        color: #FFFFFF;
        border-radius: 5px;
    }

    #btn-register-facebook {
        background: #3B5998;
        border-radius: 5px;
        color: #FFFFFF;
    }

    #btn-register-twitter {
        background: #1DA1F2;
        border-radius: 5px;
        color: #FFFFFF;
    }

    #btn-login-handphone {
        background: #E61B33;
        border-radius: 5px;
        color: #FFFFFF;
    }

    .login-handphone {
        span {
            line-height: 30px;
            font-size: 16px;
            color: #E61B33;
            display: block;
        }
    }

    #login-link {
        color: #E61B33;
        font-size: 16px;
        line-height: 24px;
        font-weight: bold;
    }

    .btn:hover {
        background-color: #333 !important;
        color: #fff;
    }

    .img-button {
        /* max-width: 20px; */
        background: #FFFFFF;
        border-radius: 5px;
    }

    .icon-section {
        z-index: 1;
        background-color: white;
        border-radius: 5px;
        width: 30px;
        height: 30px;
        margin-left: 10px;
        max-height: 30px;
        min-width: 30px;
    }

    .text-btn {
        line-height: 1;
        margin-left: 10px;
    }

    .card-body {
        position: relative;
        color: #333;
    }

    .message-box {
        position: absolute;
        background: #fff;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;

        .message-content {
            max-width: 80%;
            margin: auto;

            .btn {
                text-align: center;
            }
        }
    }

    .row-button {
        display: flex;

        .btn {
            margin: 0;
            font-weight: bold;
            font-size: 16px;
            padding: 0;
            height: 38px;
            max-width: 115px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .btn-red {
            margin-right: auto;
        }

        .info-text {
            margin-right: 10px;
        }

        .sendback {
            margin-right: auto;

            .btn {
                min-width: 160px;
            }
        }
    }
}
</style>
